import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { IS_CLOUDSEARCH_ENABLED } from '@config/config';
import { PageTemplate } from '@templates';
import { ResetPassword } from '@molecules';
import { Button } from '@atoms';
import messages from './messages';

const ButtonWrapper = styled.div`
  margin-top: 24px;
`;

export default class SettingsPage extends PureComponent {
  static propTypes = {
    isSuperAdmin: PropTypes.bool,
    forceSyncRequest: PropTypes.func,
  };

  render() {
    return (
      <PageTemplate title={<FormattedMessage {...messages.title} />}>
        <ResetPassword />
        {IS_CLOUDSEARCH_ENABLED && (
          <ButtonWrapper>
            <Button
              primary
              onClick={() => {
                this.props.forceSyncRequest();
              }}
              style={{ width: 400 }}
            >
              <FormattedMessage {...messages.forceSync} />
            </Button>
          </ButtonWrapper>
        )}
      </PageTemplate>
    );
  }
}



// WEBPACK FOOTER //
// ./components/pages/SettingsPage/SettingsPage.js